//original images
import image from "../../Assets/Logo/afr.png";
import image2 from "../../Assets/Logo/agencies.png";
import image3 from "../../Assets/Logo/air.png";
import image4 from "../../Assets/Logo/sand.png";
import image5 from "../../Assets/Logo/tutle.png";

// fade images
import img from "../../Assets/Logo/afr2.png";
import img2 from "../../Assets/Logo/agencies2.png";
import img3 from "../../Assets/Logo/air2.png";
import img4 from "../../Assets/Logo/sand2.png";
import img5 from "../../Assets/Logo/tutle2.png";

const Logos = () => {
  const images = [
    { image, image2: img },
    { image: image2, image2: img2 },
    { image: image3, image2: img3 },
    { image: image4, image2: img4 },
    { image: image5, image2: img5 },
  ];

  return (
    <div className="">
      <div className="grid grid-cols-2 gap-5 md:grid-cols-5">
        {images.map((item, i) => (
          <div
            className="last-of-type:col-span-2 md:last-of-type:col-span-1"
            key={i}
          >
            <img src={item.image2} alt="" className="mx-auto h-10 md:h-11" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Logos;
